module.exports = __webpack_public_path__ + "img/tennis9in_talk_qr.bd3775f0.png";